module.exports = __webpack_public_path__ + "fc90f703ff6f14da96b4b5ea85cfb70a.png";